import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-rx',
  templateUrl: './new-rx.component.html',
  styleUrls: ['./new-rx.component.scss']
})
export class NewRxComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
